var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76143 3.46214C9.09429 1.39143 7.18143 0 5 0C4.20143 0 3.40357 0.193571 2.69143 0.562143C1.03143 1.43214 0 3.13214 0 5C0 7.75643 2.24286 10 5 10C7.75643 10 10 7.75643 10 5C10 4.47929 9.92 3.96214 9.76143 3.46214ZM5 9.28571C2.63643 9.28571 0.714286 7.36357 0.714286 5C1.9 5 2.85714 4.04286 2.85714 2.85714V1.42857C2.85714 3.00643 4.13643 4.28571 5.71429 4.28571H9.22357C9.26286 4.52214 9.28571 4.76 9.28571 5C9.28571 7.36357 7.36357 9.28571 5 9.28571Z",
    fill: "#FFA300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85686 6.42857C3.25135 6.42857 3.57115 6.10877 3.57115 5.71429C3.57115 5.3198 3.25135 5 2.85686 5C2.46237 5 2.14258 5.3198 2.14258 5.71429C2.14258 6.10877 2.46237 6.42857 2.85686 6.42857Z",
    fill: "#FFA300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.143 6.42857C7.53749 6.42857 7.85728 6.10877 7.85728 5.71429C7.85728 5.3198 7.53749 5 7.143 5C6.74851 5 6.42871 5.3198 6.42871 5.71429C6.42871 6.10877 6.74851 6.42857 7.143 6.42857Z",
    fill: "#FFA300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAge);
export default __webpack_public_path__ + "static/media/icon-age.a4727e9ee4d3f880881b9b075ae4a8d2.svg";
export { ForwardRef as ReactComponent };